// // DeviceProvisionTable.jsx
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   Box, Paper, Table, TableHead, TableRow, TableCell,
//   TableBody, Typography, CircularProgress
// } from '@mui/material';

// const DeviceProvisionTable = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     axios.get('http://localhost:5000/api/deviceProvision')
//       .then(res => setData(res.data))
//       .catch(err => console.error("Error fetching device provisions:", err))
//       .finally(() => setLoading(false));
//   }, []);

//   return (
//     <Box sx={{ p: 4 }}>
//       <Typography variant="h5" gutterBottom>Device Provision List</Typography>

//       {loading ? (
//         <CircularProgress />
//       ) : (
//         <Paper sx={{ mt: 2 }}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>IMEI</TableCell>
//                 <TableCell>Provisioned</TableCell>
//                 <TableCell>Provisioned At</TableCell>
//                 <TableCell>Assigned Name</TableCell>
//                 <TableCell>Config ID</TableCell>
//                 <TableCell>Created At</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {data.map((row, index) => (
//                 <TableRow key={index}>
//                   <TableCell>{row.imei}</TableCell>
//                   <TableCell>{row.provisioned ? "Yes" : "No"}</TableCell>
//                   <TableCell>{new Date(row.provision_ts).toLocaleString()}</TableCell>
//                   <TableCell>{row.name_to_assign}</TableCell>
//                   <TableCell>{row.config_id_to_assign}</TableCell>
//                   <TableCell>{new Date(row.created_ts).toLocaleString()}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </Paper>
//       )}
//     </Box>
//   );
// };

// export default DeviceProvisionTable;


import React, { useEffect, useState } from 'react';
import axios from './AxiosInstance';
import {
  Box, Paper, Table, TableHead, TableRow, TableCell,
  TableBody, Typography, CircularProgress, TableContainer
} from '@mui/material';

const DeviceProvisionTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/deviceProvision')
      .then(res => setData(res.data))
      .catch(err => console.error("Error fetching device provisions:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Device Provision List
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : (
        <Paper elevation={3}>
          <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell><strong>IMEI</strong></TableCell>
                  <TableCell><strong>Provisioned</strong></TableCell>
                  <TableCell><strong>Provisioned On</strong></TableCell>
                  <TableCell><strong>Assigned Name</strong></TableCell>
                  <TableCell><strong>Config Name</strong></TableCell>
                  <TableCell><strong>Created On</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No data available.
                    </TableCell>
                  </TableRow>
                ) : (
                  data.map((row, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{row.imei || "N/A"}</TableCell>
                      <TableCell>{row.provisioned ? "Yes" : "No"}</TableCell>
                      <TableCell>
                        {row.provision_ts ? new Date(row.provision_ts).toLocaleString() : "N/A"}
                      </TableCell>
                      <TableCell>{row.name_to_assign || "N/A"}</TableCell>
                      <TableCell>
                        {row.config_name?.trim() ? row.config_name : row.config_id_to_assign}
                      </TableCell>
                      <TableCell>
                        {row.created_ts ? new Date(row.created_ts).toLocaleString() : "N/A"}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </Box>
  );
};

export default DeviceProvisionTable;

